import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { LucideMessageSquare } from '@lucide/angular';
import { PmIconComponent } from '@libs/ui';
import type { Suggestion } from '../../models/chat';

@Component({
  selector: 'pm-chat-suggestions',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="flex flex-col gap-4">
      @for (suggestion of suggestions(); track suggestion.id) {
        <button
          type="button"
          safeButtonUsage
          class="flex w-full items-start gap-2 rounded-lg border border-border-subdued bg-surface p-2.5 text-left text-xs leading-[1.3] text-content-subdued transition-colors hover:bg-surface-neutral-subdued focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-content-interactive-default"
          (click)="selected.emit(suggestion.text)"
        >
          <pm-icon
            [icon]="LucideMessageSquare"
            size="sm"
            class="shrink-0 text-content-subdued"
          />
          <span>{{ suggestion.text }}</span>
        </button>
      }
    </div>
  `,
  imports: [PmIconComponent],
})
export class ChatSuggestionsComponent {
  protected readonly LucideMessageSquare = LucideMessageSquare;

  readonly suggestions = input<Suggestion[]>([]);
  readonly selected = output<string>();
}
